import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16" {...props}><path fill="#222" d="M8 14.67A6.67 6.67 0 108 1.33a6.67 6.67 0 000 13.34z" opacity=".4" /><path fill="#222" d="M11.12 7.97C10.7 10.1 8 11.33 8 11.33S5.3 10.1 4.88 7.97c-.25-1.31.3-2.63 1.72-2.64C7.65 5.33 8 6.4 8 6.4s.35-1.06 1.4-1.06c1.42.01 1.97 1.33 1.72 2.64z" /></svg>);